<div class="input-group">
  <input type="{{showPassword ? 'text' : 'password'}}" [ngModel]="value" (ngModelChange)="onPasswordChange.emit($event)" [required]="required" [placeholder]="placeholder" class="form-control">
  <span class=" show-password-icon input-group-addon" (click)="showPassword = !showPassword">
    <i class="fa fa-eye" aria-hidden="true"></i>
  </span>
</div>
